import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '../App'
import '../styles/public.css'

// The Rails shell view exposes the SPA base path via data-base-path:
// "/" on the production subdomain, "/resources" in development.
const container = document.getElementById('root')
const basename = container?.dataset.basePath || '/'

createRoot(container).render(<App basename={basename} />)
